export default __webpack_public_path__ + "static/media/461.c298d79b.png";